export  function versionCompare(version: string, target: string): number {
  const versionParts = version.split('.').map(Number)
  const targetParts = target.split('.').map(Number)
  
  for (let i = 0; i < Math.max(versionParts.length, targetParts.length); i++) {
    const vPart = versionParts[i] || 0
    const tPart = targetParts[i] || 0
    console.log(`vPart=${vPart},tPart=${tPart}`);
    if (vPart > tPart) return 1
    if (vPart < tPart) return -1
  }
  return 0
}